import { useState } from "react";
import './App.css';
import './css/customCss.css';
import Nav from './includes/Nav';
import Footer from './includes/Footer';
import { BrowserRouter,Routes,Route } from 'react-router-dom';
import Home from './components/Home.js';
import SignUp from './components/SignUp';
import SignIn from './components/SignIn';
import AboutUs from './components/AboutUs';
import Contact from './components/Contact';
import Policy from './components/Policy.js';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import '../node_modules/bootstrap-icons/font/bootstrap-icons.min.css';

import '../node_modules/bootstrap/dist/js/bootstrap.min.js';
import '../node_modules/react-slick/dist/react-slick.js';
import "../node_modules/slick-carousel/slick/slick.css";
import "../node_modules/slick-carousel/slick/slick-theme.css";
import "../node_modules/slick-carousel/slick/slick.js";
//Slick css
import Slider from 'react-slick';
import '../node_modules/react-slick/dist/react-slick.js';
//import 'slick-carousel/slick/slick.css';
//import 'slick-carousel/slick/slick-theme.css';
import {Helmet} from "react-helmet";
import PrivateComponent from './components/PrivateComponent.js';
import HomeSlider from './components/HomeSlider.js';
import StoryDetail from "./components/StoryDetail";
import ChapterDetail from "./components/ChapterDetail";
import Category from "./components/Category";
import Profile from './components/Profile';
import config from './includes/ConfigFile.js';
import Writer from './components/Writer.js';
import { CompanyProvider, useCompany } from './components/CompanyDetails.js';
import { LanguageProvider, useLanguage } from './includes/LanguageContext.js';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import EditChapters from "./components/EditChapters.js";
import EditshowChapter from "./components/EditshowChapters.js";
import ScrollToTop from './includes/ScrollToTop.js';// Import the ScrollToTop component
import { Auth0Provider } from "@auth0/auth0-react";
import WriterDetails from "./components/WriterDetails.js";
import SearchPage from "./components/SearchPage.js";


function App() {
  return (
    <Auth0Provider
      domain="dev-bsqh2hsvo41gd2a1.us.auth0.com"
      clientId="sBcO4G1nkGwmwE8kHJQCuvjIwKfZ0ALT"
      authorizationParams={{
        redirect_uri: window.location.origin
      }}
    > 
    <CompanyProvider>
      <LanguageProvider>
      <AppContent />
      </LanguageProvider>
    </CompanyProvider>
    </Auth0Provider>
  );
}

function AppContent() {
  const company = useCompany(); //Get Company Details from database
  const {selectedLanguage, setSelectedLanguage} = useLanguage();//useState({ id: 1, name: "English" }); //language code
  //console.log("Selected Language:", selectedLanguage.name);
  //alert(`Selected Language: ${selectedLanguage.id}`);
  if (!company) {
    return ;  // Ensures `company` is not null before rendering
  }
  return (
    <div className="App">
      
        
      <BrowserRouter>
      <ScrollToTop />
      <Nav  company={company} selectedLanguage={selectedLanguage} setSelectedLanguage={setSelectedLanguage}/>
      <Routes>
      <Route path='/' element={<Home company={company} selectedLanguage={selectedLanguage} setSelectedLanguage={setSelectedLanguage}/>} />
      <Route path='/about' element={<AboutUs company={company}/>}/>
      <Route path='/category/:categoryName/:languageId' element={<Category  company={company}/>}/>
      <Route path="/category/:categoryId/:languageId" element={<Category />} />
      <Route path='/contact' element={<Contact  company={company}/>}/>
      <Route path='/signUp' element={<SignUp  company={company}/>}/>
      <Route path='/signIn' element={<SignIn company={company}/>}/>   
      <Route path='/policy' element={<Policy company={company}/>}/>
      <Route path="/story/:storyId" element={<StoryDetail company={company} />} />
      <Route path="/chapter/:chapterId/:tblPostId" element={<ChapterDetail/>} />
      <Route path="/writer" element={<Writer company={company}/>} />
      <Route path="/writer/:postId" element={<Writer />} />
      <Route path="/editChapters/:postId" element={<EditChapters />} />
      <Route path="/editshowChapters/:chapterId" element={<EditshowChapter />} />
      <Route path="/writerDetails/:writerId" element={<WriterDetails />} />
      <Route path="/search" element={<SearchPage />} />
      
      {/* Private Routes */}
      <Route element={<PrivateComponent/>} >
        <Route path='/profile' element={<Profile company={company}/>}/>
        <Route path='/logout' element={<h1>logout Page</h1>}/>
      </Route>

      </Routes>
      <Footer company={company}/>
      </BrowserRouter>
      
      {/* Toast Container Global */}
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
      
    </div>
  );
}

export default App;
